import { Driver, DriverHook } from "driver.js";
import { defaultTourConfig } from ".";
import { brandProfileSetupTourSteps } from "./ProfileSetupTour";
import { brandCampaignTourSteps } from "./CampaignTour";
import { brandAffiliatesManagementTourSteps } from "./AffiliatesManagementTour";
import { brandSupportTourSteps } from "./SupportTour";
import { brandWelcomeTourSteps } from "./BrandWelcomeTour";
import { brandAffiliatesPayoutTourSteps } from "./AffiliatesPayoutTour";
import { brandReveshareResourcesTourSteps } from "./ReveshareResourcesTour";

const startBrandGrandTour = (
  tourDriver: Driver,
  onNextClick: DriverHook,
  onPrevClick: DriverHook
) => {
  tourDriver.setConfig(defaultTourConfig);

  // Combine all tour steps in the specified order
  const allSteps = [
    ...brandWelcomeTourSteps,
    ...brandProfileSetupTourSteps,
    ...brandCampaignTourSteps,
    ...brandAffiliatesManagementTourSteps,
    ...brandAffiliatesPayoutTourSteps,
    ...brandReveshareResourcesTourSteps,
    ...brandSupportTourSteps,
  ];

  // Add navigation handlers to each step
  const stepsWithHandlers = allSteps.map((step) => ({
    ...step,
    popover: {
      ...step.popover,
      onNextClick: (element: Element | undefined, step: any, config: any) => {
        onNextClick(element, step, config);
        setTimeout(() => {
          tourDriver.moveNext();
        }, 200);
      },
      onPrevClick: (element: Element | undefined, step: any, config: any) => {
        onPrevClick(element, step, config);
        setTimeout(() => {
          tourDriver.movePrevious();
        }, 200);
      },
    },
  }));

  tourDriver.setSteps(stepsWithHandlers);
  tourDriver.drive();
};

export default startBrandGrandTour;
